import { DialogContent, Stack } from "@mui/material";

import FormFooter from "./components/FormFooter";
import SecretInfoAlert from "./components/SecretInfoAlert";
import SecretPaper from "./components/SecretPaper";

export default function SecretResult() {
	return (
		<>
			<DialogContent sx={{ mt: 0 }}>
				<Stack gap={2}>
					<SecretInfoAlert />
					<SecretPaper />
				</Stack>
			</DialogContent>
			<FormFooter />
		</>
	);
}
